import React from 'react'
import Icon from 'react-fa'
import {Panel, ButtonToolbar, ButtonGroup, Button} from 'react-bootstrap'
import {t} from '../helpers/translate.js'
import {getUserCode} from '../helpers/access'

const config = require('config');

class ApplicationForm extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  getProductFormPath(){
  	return config.default.clients[this.props.location.state.source].form_path[0].link
  }

  getRenewalId() {
    return `&renewal_id=${this.props.location.state.applicationId}`;
  }

  getParameters() {
  	return `${this.getTrackingCode()}${getUserCode(this.props.location.state.paymentProvider)}${this.getRenewalId()}`
  }

  getTrackingCode() {
    return `tracking_code=${this.props.location.state.trackingCode}`;
  }

  openFormNewTab(url) {
    window.open(url, "_blank");
  }

  getButtons(formUrl) {
    return <ButtonToolbar>
      <button className="btn button-secondary" onClick={() => {window.history.back()}}>
        <Icon name="chevron-left"/> {t('Return to Policy')}
      </button>
      <button className="btn button-primary pull-right" onClick={() => {this.openFormNewTab(formUrl)}}>
        {t('Open Form in New Tab')} <Icon name="chevron-right"/> 
      </button>
    </ButtonToolbar>
  }

  render() {
  	const formDomain = config.default[sessionStorage.getItem('org')].form_base_url;
    const formLocale = sessionStorage.getItem('locale');
    const formUrl = `${formDomain}/${formLocale}/${this.getProductFormPath()}&${this.getParameters()}`;

    return (
    	<div className="container">
        <Panel header={this.getButtons(formUrl)}>
      		<iframe 
      			className='product-iframe'
      			src={formUrl}
    			/>
        </Panel>
  		</div>
    )
  }
}
ApplicationForm.displayName = 'ApplicationForm';
export default ApplicationForm;



// WEBPACK FOOTER //
// ./src/components/ApplicationForm.js